import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { propArrayShape, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import { slideSearchPageHelper } from '../../../../helpers/page/SlideSearch';
import SlideSearchItem from '../../Common/Item/SlideSearchItem';
import SlideSearchItemsNoResult from './SlideSearchItemsNoResult';
const SlideSearchItemsInner = (props) => {
    const { items, keyword, onChange, onClickSlideSearchLink, rows, selectMap, unit, } = props;
    if (!rows.length) {
        return _jsx(SlideSearchItemsNoResult, { keyword: keyword });
    }
    return (_jsx(_Fragment, { children: rows.map((row) => (_jsx("div", Object.assign({ className: 'slide_search_list_content_item_row' }, { children: row.columns.map((column) => {
                const uuid = slideSearchPageHelper.getSlideResponseKeyFromUnitValue(column, unit.value);
                return (_jsx(SlideSearchItem, { checked: !!selectMap[uuid], item: column, items: items, onChange: onChange, onClickSlideSearchLink: onClickSlideSearchLink, unit: unit, uuid: uuid }, uuid));
            }) }), row.id))) }));
};
SlideSearchItemsInner.propTypes = {
    items: propArrayShape().isRequired,
    keyword: propStr().isRequired,
    onChange: propFunc().isRequired,
    onClickSlideSearchLink: propFunc(),
    rows: propArrayShape().isRequired,
    selectMap: propShape().isRequired,
    unit: propShape().isRequired,
};
SlideSearchItemsInner.defaultProps = {
    onClickSlideSearchLink: null,
};
export default SlideSearchItemsInner;
